import { render } from "./SurveyQuestionCheckbox.vue?vue&type=template&id=86263fc8&scoped=true"
import script from "./SurveyQuestionCheckbox.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionCheckbox.vue?vue&type=script&lang=js"

import "./SurveyQuestionCheckbox.vue?vue&type=style&index=0&id=86263fc8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-86263fc8"

export default script